<template>
  <footer class="site-footer">
    <slot />

    <nav>
      <div class="wrapper">
        <div class="column">
          <input id="footer-nav-shop" class="u-hiddenVisually footer-nav-toggle" type="checkbox" name="footer-nav" />
          <label for="footer-nav-shop">
            <h5>Shop</h5>
          </label>
          <ul>
            <li><a href="/shop">All Products</a></li>
            <li><a href="/shop?menu%5Bproduct__collections__names%5D=Our%20Favorites">Our Favorites</a></li>
            <li><a href="/shop?menu%5Bproduct__collections__names%5D=Featured%20Partners">Featured Partners</a></li>
            <li><a href="/discounts">Discounts</a></li>
            <li><a href="/tags">Tags</a></li>
            <li><a href="https://support.cottonbureau.com">Help</a></li>
          </ul>
        </div>
        <div class="column">
          <input id="footer-nav-sell" class="u-hiddenVisually footer-nav-toggle" type="checkbox" name="footer-nav" />
          <label for="footer-nav-sell">
            <h5>Sell</h5>
          </label>
          <ul>
            <li><a href="/create-a-product">Create a Product</a></li>
            <li><a href="/how-it-works">How It Works</a></li>
            <li><a href="/custom">Custom</a></li>
            <li><a href="/plus">Plus</a></li>
          </ul>
        </div>
        <div class="column">
          <input id="footer-nav-company" class="u-hiddenVisually footer-nav-toggle" type="checkbox" name="footer-nav" />
          <label for="footer-nav-company">
            <h5>Company</h5>
          </label>
          <ul>
            <li><a href="/about-us">About Us</a></li>
            <li><a href="https://blog.cottonbureau.com">The Back Room Blog</a></li>
            <li><a href="http://eepurl.com/AXmkH">Newsletter</a></li>
          </ul>
        </div>
        <div class="column">
          <input id="footer-nav-blank" class="u-hiddenVisually footer-nav-toggle" type="checkbox" name="footer-nav" />
          <label for="footer-nav-blank">
            <h5>Fine Print</h5>
          </label>
          <ul>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms-of-service">Terms of Service</a></li>
          </ul>
        </div>
        <div class="column">
          <input id="footer-nav-account" class="u-hiddenVisually footer-nav-toggle" type="checkbox" name="footer-nav" />
          <label for="footer-nav-account">
            <h5>Account</h5>
          </label>
          <ul>
            <template v-if="cottonBureauStore.user && cottonBureauStore.user.isAuth">
              <li><a href="/account">My Account</a></li>
              <li><a href="/sign-out">Sign Out</a></li>
            </template>
            <template v-else>
              <li><a href="/sign-in">Sign In</a></li>
              <li><a href="/sign-up">Create an Account</a></li>
            </template>
          </ul>
        </div>
        <div class="column">
          <input id="footer-nav-contact" class="u-hiddenVisually footer-nav-toggle" type="checkbox" name="footer-nav" />
          <label for="footer-nav-contact">
            <h5>Contact</h5>
          </label>
          <ul>
            <li>
              <a href="mailto:us@cottonbureau.com">us@cottonbureau.com</a>
            </li>
            <li>
              <a href="https://bsky.app/profile/cottonbureau.com">Bluesky</a>
            </li>
            <li>
              <a href="https://mastodon.social/@cottonbureau">Mastodon</a>
            </li>
            <li><a href="https://instagram.com/cottonbureau">Instagram</a></li>
            <!-- <li class="message">Support available 10am–6pm ET Monday through Friday</li> -->
          </ul>
        </div>
      </div>
    </nav>
    <div class="copyright">&copy; Cotton Bureau. All rights reserved.</div>
    <div class="ckeckout-links">
      <ul>
        <li><a href="/">Home</a></li>
        <li><a href="/shop">Shop</a></li>
        <li><a href="/about-us">About Us</a></li>
        <li><a href="https://support.cottonbureau.com/">FAQ</a></li>
        <li><a href="/privacy-policy">Privacy</a></li>
        <li><a href="/terms-of-service">Terms</a></li>
        <li><a href="mailto:us@cottonbureau.com">Contact Us</a></li>
      </ul>
    </div>
  </footer>
</template>
<script>
import { mapStores } from "pinia";
import { useCottonBureauStore } from "@/store/index.js";

export default {
  components: {},

  computed: {
    ...mapStores(useCottonBureauStore),
  },
};
</script>
